import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useSearchParams } from "react-router-dom";
import FileSaver from "file-saver";
import CopyToClipboard from "react-copy-to-clipboard";

import { getSite } from "../features/chatbot/getSiteDataSlice";
import { sendQuestion } from "../features/chatbot/sendQuestionSlice";

import LeftSidebar from "../layout/ChatBotSidebar";

import ChatPageFooter from "./ChatPageFooter";

import importAll from "../components/chat-component/images";
import { OK } from "../constants/statusCode";
import ChatBlock from "../components/chat-component/chatpage-setting-drodown/ChatBlock";
import { sendReactionValue } from "../features/chatbot/sendReactionValueSlice";
import { getRandomText, setandgetCookies } from "../utils/utils";
import ShareDocumentModal from "../components/chat-component/modal/ShareDocumentModal";

import { Worker } from "@react-pdf-viewer/core";
import { toolbarPlugin } from "@react-pdf-viewer/toolbar";
// Core viewer
import { Viewer } from "@react-pdf-viewer/core";

// Import styles
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/toolbar/lib/styles/index.css";
import { sendShareDocumentSettings } from "../features/chatbot/sendShareDocumentSettings";
import moment from "moment/moment";
import { resetSite } from "../features/chatbot/resetSiteDataSlice";

import FilterComponent from "../common/filter";
import { getConversations } from "../features/chatbot/getConversationsSlice";
import { getLabels } from "../features/chatbot/labelListSlice";

const images = importAll(
  require.context("../assets/images/", false, /\.(png|jpe?g|svg|GIF|webp)$/)
);

const NewChatPage = () => {
  const dispatch = useDispatch();

  const [show, setShow] = useState("");

  const [referenceDocument, setReferenceDocument] = useState("");

  const [basePromptValue, setBasePromptValue] = useState(
    'You are an AI assistant in a conversation with a human.\nAnswer their questions as truthfully as possible using the provided text.If the answer is not contained within the text, say "Hmm, I am not sure". Reply in the same language as the question.'
  );

  const [initialMessage, setInitialMessage] = useState(
    "Hi! What can I help you with?"
  );

  const [documentPageNumber, setDocumentPageNumber] = useState(0);

  const { siteData } = useSelector((state) => state.getSiteData);

  const { particularConversationData } = useSelector(
    (state) => state.getParticularConversationData
  );

  const [documentLink, setDocumentLink] = useState(false);

  const [documentType, setDocumentType] = useState("");

  const [html, setHtml] = useState(null);

  const [contentFromSearch, setContentFromSearch] = useState("All documents");

  const target = useRef(null);

  const [source, setSource] = useState(true);

  const [loadingPropmptData, setLoadingPromptData] = useState([]);

  const [exportJSONLoadingPromptData, setExportJSONLoadingPromptData] =
    useState([]);

  const [lengthValue, setLengthValue] = useState("Detailed");
  const [likeValue, setLikedValue] = useState(false);

  const [switchChange, handleSwitchChange] = useState(false);

  const [selectedOptions, setSelectedOptions] = useState([]);

  const [selectedLabelOptions, setSelectedLabelOptions] = useState([]);

  const [responseTone, setResponseTone] = useState("Conversational");

  const [typeOfAnswer, setTypeOfAnswer] = useState("ai_driven_answer");

  const [selectedLabel, setSelectedLabel] = useState("all labels");

  const [selectedDocument, setSelectedDocument] = useState("all documents");

  const [selectedConversation, setSelectedConversation] = useState("");

  const [roleValue, setRoleValue] = useState("");

  const [selectedConversationName, setSelectedConversationName] = useState("");

  let loading = useRef("");

  const [inputedQuestion, setInputtedQuestion] = useState("");
  const [showModal, setShowModal] = useState(false);

  const { pathname, search } = useLocation();
  const demo = pathname.split("/").pop();

  const searchParams = new URLSearchParams(search);
  var location = searchParams.get("debug");

  const bottom = useRef(null);

  const scrollToBottom = () => {
    bottom?.current?.scrollIntoView({ behavior: "smooth" });
  };

  const toolbarPluginInstance = toolbarPlugin();
  const { Toolbar } = toolbarPluginInstance;

  const [toolTipToggle, handleTooltipToggle] = useState(false);

  let payloadData = useRef({ name: "", filter: [], conversationId: "" });

  const filterMenu = [
    {
      id: "filterby",
      label: "Filter by",
    },
    {
      id: "document",
      label: "Documents",
    },
    {
      id: "label",
      label: "Labels",
    },
  ];

  let filterOptions = filterMenu?.map((el) => {
    return {
      name: el.id,
      label: el.label,
      key: el.id,
    };
  });

  const [filterOption, setFilterOption] = useState(filterOptions);

  const [selectedFilter, setSelectedFilter] = useState([]);

  useEffect(() => {
    setandgetCookies();
    dispatch(getSite(demo));
    dispatch(getConversations(demo));
    dispatch(getLabels(demo));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setShow("");
    }, 2000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  useEffect(() => {
    const fetchHtml = async () => {
      if (referenceDocument !== "") {
        const response = await fetch(referenceDocument);
        const htmlContent = await response.text();
        setHtml(htmlContent);
      }
    };

    fetchHtml();
  }, [referenceDocument]);

  useEffect(() => {
    if (siteData?.details?.project_setting) {
      setDocumentLink(siteData?.details.is_public === 1 ? true : false);
      handleTooltipToggle(siteData?.details?.project_setting?.tooltip_toggle);
      setLengthValue(siteData?.details?.project_setting?.answer_symantic);
      setTypeOfAnswer(siteData?.details?.project_setting?.answer_type);
      setResponseTone(siteData?.details?.project_setting?.tone);
      setSource(
        siteData?.details?.project_setting?.wants_source === 1 ? true : false
      );
      setRoleValue(siteData?.details.project_setting?.role_value);
      handleSwitchChange(siteData?.details?.project_setting?.debug_switch);
      setBasePromptValue(siteData?.details?.project_setting?.prompt_data);
      if (
        siteData?.details?.project_setting?.initial_message !== "" &&
        siteData?.details?.project_setting?.initial_message !== undefined &&
        siteData?.details?.project_setting?.initial_message !== null
      ) {
        setInitialMessage(siteData?.details?.project_setting?.initial_message);
      } else {
        setInitialMessage("Hi! What can I help you with?");
      }
    }
  }, [siteData]);

  useEffect(() => {
    if (
      particularConversationData?.conversations !== undefined &&
      particularConversationData?.conversations?.length !== 0
    ) {
      setLoadingPromptData([]);
      let filterContent = [];
      let preparedPrompt = "";
      particularConversationData?.conversations?.map((_value, _index) =>
        setLoadingPromptData((value) => {
          filterContent = [];
          if (_value.weaviate_response?.reference_contents.length > 0) {
            _value.weaviate_response?.reference_contents.map((_data, _idx) => {
              if (filterContent.length === 0) {
                filterContent.push(_data);
              } else {
                filterContent.filter((_contentData, _index) => {
                  return (
                    _contentData?.fileName !== _data?.fileName &&
                    filterContent.push(_data)
                  );
                });
              }
            });
          }
          // let promptData = _value.weaviate_response.preparedPrompt;
          /*  preparedPrompt = promptData.replaceAll(
                      "\n",
                      "<br/>"
                    ); */
          return [
            ...value,
            {
              ...{
                questionId: _value.uuid,
                question: _value.question,
                answer: _value.answer,
                like: _value.is_liked,
                optionalAnswer1: _value.weaviate_response
                  ? _value.weaviate_response.reference_contents.length > 0 &&
                    filterContent
                  : false,
                referenceFiles:
                  _value.weaviate_response &&
                  _value.weaviate_response.referenceFiles.length > 0 &&
                  _value.weaviate_response.referenceFiles,
                preparedPrompt:
                  _value.weaviate_response &&
                  _value.weaviate_response.preparedPrompt,
              },
              ..._value.weaviate_response,
              conversation: {
                uuid: _value.uuid,
              },
            },
          ];
        })
      );
    } else {
      setLoadingPromptData([]);
    }
  }, [particularConversationData]);

  useEffect(() => {
    // scrollToBottom();
    if (inputedQuestion === "" && !likeValue) {
      bottom?.current?.scrollIntoView({ behavior: "instant", block: "end" });
    } else {
      setLikedValue(false);
    }
  }, [loadingPropmptData]);

  const handleFaqSend = async (setKeyPressed) => {
    setReferenceDocument("");
    scrollToBottom();
    setLoadingPromptData([
      ...loadingPropmptData,
      {
        question: inputedQuestion,
        answer: "",
        loading: true,
      },
    ]);
    setExportJSONLoadingPromptData([
      ...exportJSONLoadingPromptData,
      {
        question: inputedQuestion,
        answer: "",
        loading: true,
      },
    ]);
    loading.current = true;
    setInputtedQuestion("");
    let values = {
      prompt: inputedQuestion,
      answer_type: typeOfAnswer,
      answer_symantic: lengthValue.toLowerCase(),
      wants_source: source,
      project_slug: demo,
      act_as: roleValue,
      conversation_uuid: selectedConversation ? selectedConversation : null,
      filter:
        payloadData.current.filter.length > 0
          ? payloadData.current.filter
          : null,
    };
    responseTone !== "" && (values.tone = responseTone.toLowerCase());
    const faqData = await dispatch(
      sendQuestion({ values: values, projectName: demo })
    );

    if (faqData?.payload?.status === OK) {
      let finalData = "";
      let optionalAnswer1 = "";
      let filterContent = [];
      let promptAnswer = "";
      let preparedPrompt = "";
      if (
        faqData?.payload.data.data.prompt_answer === "" ||
        faqData?.payload.data.data.prompt_answer === null
      ) {
        finalData =
          "I'm sorry, I don't have an answer for that at the moment. Is there anything else I can help you with?";
      } else {
        finalData = faqData?.payload?.data?.data?.prompt_answer.replace(
          /\\n/g,
          "<br/>"
        );
        if (faqData?.payload?.data?.data?.reference_contents.length > 0) {
          faqData?.payload?.data?.data?.reference_contents.map(
            (_data, _idx) => {
              if (filterContent.length === 0) {
                filterContent.push(_data);
              } else {
                filterContent.filter((_contentData, _index) => {
                  return (
                    _contentData.fileName !== _data.fileName &&
                    filterContent.push(_data)
                  );
                });
              }
            }
          );
        }
        promptAnswer = faqData?.payload?.data?.data?.prompt_answer;
        preparedPrompt = faqData?.payload?.data?.data?.preparedPrompt.replace(
          /\\n/g,
          "<br/>"
        );
      }
      setLoadingPromptData([
        ...loadingPropmptData,
        {
          questionId: faqData?.payload?.data?.data?.conversation?.uuid,
          question: inputedQuestion,
          answer: finalData,
          /*  reference1: faqData?.payload?.data?.data?.reference_contents[0],
                    reference2: faqData?.payload?.data?.data?.reference_contents[1], */
          optionalAnswer1:
            faqData?.payload?.data?.data?.reference_contents.length > 0 &&
            filterContent,
          referenceFiles:
            faqData?.payload?.data?.data?.referenceFiles.length > 0 &&
            faqData?.payload?.data?.data?.referenceFiles,
          // optionalAnswer2: optionalAnswer2,
          prompt_answer: promptAnswer,
          preparedPrompt: preparedPrompt,
          loading: false,
          errorData: "",
        },
      ]);
      setExportJSONLoadingPromptData([
        ...exportJSONLoadingPromptData,
        {
          question: inputedQuestion,
          answer: finalData,
          prompt_answer: promptAnswer,
        },
      ]);
      const conversationData = await dispatch(getConversations(demo));

      setSelectedConversation(
        conversationData.payload.data.responseData.userConversations[
          conversationData.payload.data.responseData.userConversations.length -
            1
        ].uuid
      );
    } else {
      setLoadingPromptData([
        ...loadingPropmptData,
        {
          question: inputedQuestion,
          answer: "",
          loading: false,
          errorData: faqData?.payload?.response?.data?.message,
        },
      ]);
      setExportJSONLoadingPromptData([
        ...exportJSONLoadingPromptData,
        {
          question: inputedQuestion,
          answer: "",
          errorData: faqData?.payload?.response?.data?.message,
        },
      ]);
    }
    loading.current = false;
    setInputtedQuestion("");
    scrollToBottom();
    if (setKeyPressed !== undefined) {
      setKeyPressed(false);
    }
  };

  const handleAnswerResponse = async (questionId, _response) => {
    setLikedValue(true);
    const response = await dispatch(
      sendReactionValue({
        questionId: questionId,
        _response: _response,
      })
    );
    if (response?.payload?.status === OK) {
      setLoadingPromptData((prevState) =>
        prevState.map((item, index) => {
          if (item.questionId === questionId) {
            return { ...item, like: _response };
          }
          return item;
        })
      );
    }
  };

  const resetSiteData = async () => {
    if (loadingPropmptData.length > 0) {
      const { payload } = await dispatch(resetSite(demo));
      if (payload.status === OK) {
        setLoadingPromptData([]);
      }
    }
  };

  const exportText = () => {
    if (loadingPropmptData.length > 0) {
      let text = "";
      loadingPropmptData.forEach((data) => {
        text += `Question: ${data.question}\nAnswer:${data.answer}\n\n`;
      });
      const blob = new Blob([text], { type: "text/plain;charset=utf-8" });
      FileSaver.saveAs(
        blob,
        `${
          JSON.parse(localStorage.getItem("_user"))["projects"][0]["name"]
        }-${moment().format("DD.MM.YYYY-h.mm.ss a")}.txt`
      );
    }
  };

  const exportMarkup = () => {
    if (loadingPropmptData.length > 0) {
      let markup = `
    <html>
      <head>
        <title>${
          JSON.parse(localStorage.getItem("_user"))["projects"][0]["name"]
        }</title>
      </head>
      <body>
        <h3>${
          JSON.parse(localStorage.getItem("_user"))["projects"][0]["name"]
        }</h3>
  `;
      loadingPropmptData.forEach((data) => {
        markup += `
        <h4>Question: ${data.question}</h4>
        <p>Answer: ${data.answer}</p>
    `;
      });
      markup += `
      </body>
    </html>
  `;
      const blob = new Blob([markup], { type: "text/html;charset=utf-8" });
      FileSaver.saveAs(
        blob,
        `${
          JSON.parse(localStorage.getItem("_user"))["projects"][0]["name"]
        }-${moment().format("DD.MM.YYYY-h.mm.ss a")}.html`
      );
    }
  };

  const exportJson = () => {
    if (loadingPropmptData.length > 0) {
      const blob = new Blob(
        [
          JSON.stringify(
            location === "true" || switchChange
              ? loadingPropmptData
              : exportJSONLoadingPromptData
          ),
        ],
        {
          type: "application/json;charset=utf-8",
        }
      );
      FileSaver.saveAs(
        blob,
        `${
          JSON.parse(localStorage.getItem("_user"))["projects"][0]["name"]
        }-${moment().format("DD.MM.YYYY-h.mm.ss a")}.json`
      );
    }
  };

  /* const saveSettingsData = async () => {
      const values = {
        wants_source: source === true ? 1 : 0,
        answer_type: typeOfAnswer,
        answer_symantic: lengthValue,
        tone: responseTone,
        role_value: roleValue,
        tooltip_toggle: toolTipToggle,
      };
      await dispatch(
        sendShareDocumentSettings({
          values: values,
          project_slug_name: demo,
        })
      );
    }; */

  const saveSettingsData = async (values) => {
    await dispatch(
      sendShareDocumentSettings({
        values: values,
        project_slug_name: demo,
      })
    );
  };

  const setDebugData = (_debugData) => {
    const debugData = _debugData.replace(/\\n/g, "<br/>");
    return debugData;
  };

  return (
    <div className="main-wrapper">
      <div className="remove-sidebar">
        {siteData?.length !== 0 && (
          <>
            <div className="dashbord-content">
              <div className="dashbord-content-inner">
                <LeftSidebar
                  contentFromSearch={contentFromSearch}
                  setContentFromSearch={setContentFromSearch}
                  siteData={siteData}
                  setSelectedLabel={setSelectedLabel}
                  selectedLabel={selectedLabel}
                  selectedDocument={selectedDocument}
                  setSelectedDocument={setSelectedDocument}
                  selectedConversation={selectedConversation}
                  setSelectedConversation={setSelectedConversation}
                  projectSlug={demo}
                  setLoadingPromptData={setLoadingPromptData}
                  setSelectedConversationName={setSelectedConversationName}
                  setSelectedOptions={setSelectedOptions}
                  selectedLabelOptions={selectedLabelOptions}
                  setSelectedLabelOptions={setSelectedLabelOptions}
                  setFilterOption={setFilterOption}
                  filterOptions={filterOptions}
                  selectedFilter={selectedFilter}
                  setSelectedFilter={setSelectedFilter}
                  selectedConversationName={selectedConversationName}
                />

                <div className="content-right-box">
                  <div className="intro-table-search container-fluid">
                    <div className="row align-items-center py-3">
                      <div className="col-12 col-lg-4 col-xl-5 col-xxl-6 title-left filter-left">
                        {/* this div is for the filter component  icon  */}
                        <div className="text-blueGray-700">
                          <FilterComponent
                            headCells={filterMenu}
                            filterOptions={filterOptions}
                            setFilterOption={setFilterOption}
                            filterOption={filterOption}
                            selectedConversationName={selectedConversationName}
                            selectedConversation={selectedConversation}
                            payloadData={payloadData.current}
                            setSelectedOptions={setSelectedOptions}
                            selectedOptions={selectedOptions}
                            selectedLabelOptions={selectedLabelOptions}
                            setSelectedLabelOptions={setSelectedLabelOptions}
                            selectedFilter={selectedFilter}
                            setSelectedFilter={setSelectedFilter}
                          />
                        </div>
                        {/*   <h5 className="intro-title chatbot-title">
                          {contentFromSearch}
                        </h5> */}
                      </div>
                      <div className="col-12 col-lg-8 col-xxl-6 col-xl-7 mt-md-0 d-flex justify-content-end title-right">
                        <button
                          className="btn btn-primary-md create-doc-btn share-chatbot mt-0 btn-primary-md"
                          onClick={() => setShowModal(true)}
                        >
                          <img
                            alt=""
                            className="chat-btn-icon"
                            src={images["share.svg"]}
                          />
                          <span className="mobile-hide">Share Chatbot</span>
                        </button>
                        <button
                          type="button"
                          className="btn btn-danger-md ms-3"
                          onClick={() => {
                            resetSiteData();
                          }}
                        >
                          <img
                            src={images["reset.svg"]}
                            alt=""
                            className="trash-icn me-1"
                          />
                          <span className="mobile-hide">Reset</span>
                        </button>
                        <div className="dropdown export-dropdown common-dropdown ms-3">
                          <button
                            type="button"
                            className="btn dropdown-toggle"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <img
                              src={images["export.svg"]}
                              alt=""
                              className="btn-space"
                            />
                            <span className="mobile-hide">Export</span>
                            <img src={images["dropdown-arrow.svg"]} alt="" />
                          </button>
                          <ul className="dropdown-menu">
                            <li>
                              <a
                                className="dropdown-item"
                                href="#"
                                onClick={() => exportText()}
                              >
                                {" "}
                                Text
                              </a>
                            </li>
                            <li>
                              <a
                                className="dropdown-item"
                                href="#"
                                onClick={() => exportJson()}
                              >
                                Json
                              </a>
                            </li>
                            <li>
                              <a
                                className="dropdown-item"
                                href="#"
                                onClick={() => exportMarkup()}
                              >
                                {" "}
                                Markdown
                              </a>
                            </li>
                          </ul>
                        </div>
                        <div className="dropdown setting-sidebar ms-3">
                          <div
                            className="offcanvas offcanvas-end setting-bar"
                            tabIndex="-1"
                            id="offcanvasRight"
                            aria-labelledby="offcanvasRightLabel"
                          >
                            <div className="setting-block">
                              <div className="setting-head">
                                <div className="row align-items-center">
                                  <div className="col-8">
                                    <h3>Settings</h3>
                                  </div>
                                  <div className="col-4 text-end">
                                    <a
                                      href="#"
                                      className="close-setting"
                                      data-bs-toggle="offcanvas"
                                      // onClick={() => saveSettingsData()}
                                    >
                                      <img
                                        src={images["close-setting.svg"]}
                                        alt=""
                                      />
                                    </a>
                                  </div>
                                </div>
                              </div>
                              <div className="form-group mb-4">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={source}
                                    onChange={() => {
                                      setSource(!source);
                                      saveSettingsData({
                                        answer_type: typeOfAnswer,
                                        wants_source: source === true ? 0 : 1,
                                        answer_symantic: lengthValue,
                                        tone: responseTone,
                                        role_value: roleValue,
                                        tooltip_toggle: toolTipToggle,
                                        debug_switch: switchChange,
                                        prompt_data: basePromptValue,
                                        initial_message: initialMessage,
                                      });
                                    }}
                                    id="al-1"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="al-1"
                                  >
                                    [Cite sources] in answers
                                  </label>
                                </div>
                              </div>
                              <div className="row align-items-center">
                                <div className="col-12">
                                  <h3>Answer Style</h3>
                                </div>
                              </div>
                              <div className="length-block">
                                <ul
                                  className="length-btns d-flex justify-content-between"
                                  onClick={(e) => {
                                    setTypeOfAnswer(
                                      e.target.innerHTML === "Data-Driven"
                                        ? "data_driven_answer"
                                        : "ai_driven_answer"
                                    );
                                    saveSettingsData({
                                      answer_type:
                                        e.target.innerHTML === "Data-Driven"
                                          ? "data_driven_answer"
                                          : "ai_driven_answer",
                                      wants_source: source === true ? 1 : 0,
                                      answer_symantic: lengthValue,
                                      tone: responseTone,
                                      role_value: roleValue,
                                      tooltip_toggle: toolTipToggle,
                                      debug_switch: switchChange,
                                      prompt_data: basePromptValue,
                                      initial_message: initialMessage,
                                    });
                                  }}
                                >
                                  <li
                                    className={`col-6 ${
                                      typeOfAnswer === "data_driven_answer"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    <a href="#" className="btn">
                                      Data-Driven
                                    </a>
                                  </li>
                                  <li
                                    className={`col-6 ${
                                      typeOfAnswer === "ai_driven_answer"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    <a href="#" className="btn">
                                      AI-Enhanced
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="setting-block">
                              <div className="row align-items-center">
                                <div className="col-12">
                                  <h3>Length</h3>
                                </div>
                              </div>
                              <div className="length-block">
                                <ul
                                  className="length-btns"
                                  onClick={(e) => {
                                    setLengthValue(e.target.innerHTML);
                                    saveSettingsData({
                                      answer_symantic: e.target.innerHTML,
                                      wants_source: source === true ? 1 : 0,
                                      answer_type: typeOfAnswer,
                                      tone: responseTone,
                                      role_value: roleValue,
                                      tooltip_toggle: toolTipToggle,
                                      debug_switch: switchChange,
                                      prompt_data: basePromptValue,
                                      initial_message: initialMessage,
                                    });
                                  }}
                                >
                                  <li
                                    className={`col-4 ${
                                      (lengthValue === "Brief" ||
                                        lengthValue === "brief") &&
                                      "active"
                                    }`}
                                  >
                                    <a className="btn">Brief</a>
                                  </li>
                                  <li
                                    className={`col-4 ${
                                      (lengthValue === "Concise" ||
                                        lengthValue === "concise") &&
                                      "active"
                                    }`}
                                  >
                                    <a className="btn">Concise</a>
                                  </li>
                                  <li
                                    className={`col-4 ${
                                      (lengthValue === "Detailed" ||
                                        lengthValue === "detailed") &&
                                      "active"
                                    }`}
                                  >
                                    <a className="btn">Detailed</a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="setting-block">
                              <div className="row align-items-center">
                                <div className="col-8">
                                  <h3>Play Role As</h3>
                                </div>
                                <div className="col-4 text-end">
                                  <span
                                    className="info-btn"
                                    data-bs-toggle="modal"
                                    data-bs-target="#infoModal"
                                  >
                                    <img src={images["info.svg"]} alt="" />
                                  </span>
                                </div>
                              </div>
                              <div className="role-block">
                                <textarea
                                  className="form-control"
                                  placeholder="Add role"
                                  onChange={(e) => setRoleValue(e.target.value)}
                                  onBlur={(e) => {
                                    if (e.target.value.length > 0) {
                                      saveSettingsData({
                                        answer_symantic: lengthValue,
                                        wants_source: source === true ? 1 : 0,
                                        answer_type: typeOfAnswer,
                                        tone: responseTone,
                                        role_value: e.target.value,
                                        tooltip_toggle: toolTipToggle,
                                        debug_switch: switchChange,
                                        prompt_data: basePromptValue,
                                        initial_message: initialMessage,
                                      });
                                    }
                                  }}
                                  value={roleValue}
                                ></textarea>
                              </div>
                            </div>
                            <ChatBlock
                              setResponseTone={setResponseTone}
                              responseTone={responseTone}
                              lengthValue={lengthValue}
                              source={source}
                              typeOfAnswer={typeOfAnswer}
                              toolTipToggle={toolTipToggle}
                              roleValue={roleValue}
                              switchChange={switchChange}
                              basePromptValue={basePromptValue}
                              initialMessage={initialMessage}
                              saveSettingsData={saveSettingsData}
                            />
                            <div className="form-group align-items-center d-flex">
                              <label className="form-label w-100 mb-0">
                                Show Tooltip
                              </label>
                              <div className="custom-switch-main flex-shrink-1">
                                <input
                                  type="checkbox"
                                  id="toolTipSwitch"
                                  onChange={(e) => {
                                    handleTooltipToggle(e.target.checked);
                                    saveSettingsData({
                                      answer_symantic: lengthValue,
                                      wants_source: source === true ? 1 : 0,
                                      answer_type: typeOfAnswer,
                                      tone: responseTone,
                                      role_value: roleValue,
                                      tooltip_toggle: e.target.checked,
                                      debug_switch: switchChange,
                                      prompt_data: basePromptValue,
                                      initial_message: initialMessage,
                                    });
                                  }}
                                  checked={toolTipToggle}
                                />
                                <label htmlFor="toolTipSwitch">Toggle</label>
                              </div>
                            </div>
                            <div className="form-group align-items-center d-flex">
                              <label className="form-label w-100 mb-0">
                                Debug Mode
                              </label>
                              <div className="custom-switch-main flex-shrink-1">
                                <input
                                  type="checkbox"
                                  id="debugSwitch"
                                  onChange={(e) => {
                                    handleSwitchChange(e.target.checked);
                                    saveSettingsData({
                                      answer_symantic: lengthValue,
                                      wants_source: source === true ? 1 : 0,
                                      answer_type: typeOfAnswer,
                                      tone: responseTone,
                                      role_value: roleValue,
                                      tooltip_toggle: toolTipToggle,
                                      debug_switch: e.target.checked,
                                      prompt_data: basePromptValue,
                                      initial_message: initialMessage,
                                    });
                                  }}
                                  checked={switchChange}
                                />
                                <label htmlFor="debugSwitch">Toggle</label>
                              </div>
                            </div>
                          </div>
                          <button
                            type="button"
                            className="btn dropdown-toggle"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasRight"
                            aria-controls="offcanvasRight"
                          >
                            <img src={images["setting-chat.svg"]} alt="" />
                          </button>
                        </div>
                        {/* <div className="dropdown setting-sidebar ms-3">
                          <div
                            className="offcanvas offcanvas-end setting-bar edit-setting-sidebar"
                            tabIndex="-1"
                            id="offCanvasSettingsRight"
                            aria-labelledby="offCanvasSettingsRightLabel"
                          >
                            <div className="setting-block edit-chatbot border-bottom-0">
                              <div className="form-group">
                                <div className="row align-items-top my-2">
                                  <div className="col-8">
                                    <h3>Base Prompt</h3>
                                  </div>
                                  <div className="col-4 text-end">
                                    <span
                                      className="info-btn"
                                      onClick={() => {
                                        setBasePromptValue(
                                          'You are an AI assistant in a conversation with a human.\nAnswer their questions as truthfully as possible using the provided text.If the answer is not contained within the text, say "Hmm, I am not sure". Reply in the same language as the question.'
                                        );
                                        saveSettingsData({
                                          answer_symantic: lengthValue,
                                          wants_source: source === true ? 1 : 0,
                                          answer_type: typeOfAnswer,
                                          tone: responseTone,
                                          role_value: roleValue,
                                          tooltip_toggle: toolTipToggle,
                                          debug_switch: switchChange,
                                          prompt_data:
                                            'You are an AI assistant in a conversation with a human.\nAnswer their questions as truthfully as possible using the provided text.If the answer is not contained within the text, say "Hmm, I am not sure". Reply in the same language as the question.',
                                          initial_message: initialMessage,
                                        });
                                      }}
                                    >
                                      Reset
                                    </span>
                                  </div>
                                  <div className="col-12">
                                    <textarea
                                      className="form-control"
                                      rows={"1"}
                                      value={basePromptValue}
                                      onBlur={(e) =>
                                        saveSettingsData({
                                          answer_symantic: lengthValue,
                                          wants_source: source === true ? 1 : 0,
                                          answer_type: typeOfAnswer,
                                          tone: responseTone,
                                          role_value: roleValue,
                                          tooltip_toggle: toolTipToggle,
                                          debug_switch: switchChange,
                                          prompt_data: e.target.value,
                                          initial_message: initialMessage,
                                        })
                                      }
                                      onChange={(e) =>
                                        setBasePromptValue(e.target.value)
                                      }
                                    ></textarea>
                                  </div>
                                </div>
                              </div>
                              <div className="form-group mb-0">
                                <div className="row align-items-top my-2">
                                  <div className="col-8">
                                    <h3>Initial Message</h3>
                                  </div>
                                  <div className="col-4 text-end">
                                    <span
                                      className="info-btn"
                                      onClick={() => {
                                        setInitialMessage(
                                          "Hi! What can I help you with?"
                                        );
                                        saveSettingsData({
                                          answer_symantic: lengthValue,
                                          wants_source: source === true ? 1 : 0,
                                          answer_type: typeOfAnswer,
                                          tone: responseTone,
                                          role_value: roleValue,
                                          tooltip_toggle: toolTipToggle,
                                          debug_switch: switchChange,
                                          prompt_data: basePromptValue,
                                          initial_message:
                                            "Hi! What can I help you with?",
                                        });
                                      }}
                                    >
                                      Reset
                                    </span>
                                  </div>
                                  <div className="col-12">
                                    <input
                                      type={"text"}
                                      className="form-control"
                                      onChange={(e) =>
                                        setInitialMessage(e.target.value)
                                      }
                                      value={initialMessage}
                                      onBlur={(e) =>
                                        saveSettingsData({
                                          answer_type: typeOfAnswer,
                                          wants_source: source === true ? 0 : 1,
                                          answer_symantic: lengthValue,
                                          tone: responseTone,
                                          role_value: roleValue,
                                          tooltip_toggle: toolTipToggle,
                                          debug_switch: switchChange,
                                          prompt_data: basePromptValue,
                                          initial_message: e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="form-group align-items-center d-flex">
                                <label className="form-label w-100 mb-0 mt-2">
                                  Debug Mode
                                </label>
                                <div className="custom-switch-main flex-shrink-1">
                                  <input
                                    type="checkbox"
                                    id="debugSwitch"
                                    onChange={(e) => {
                                      handleSwitchChange(e.target.checked);
                                      saveSettingsData({
                                        answer_symantic: lengthValue,
                                        wants_source: source === true ? 1 : 0,
                                        answer_type: typeOfAnswer,
                                        tone: responseTone,
                                        role_value: roleValue,
                                        tooltip_toggle: toolTipToggle,
                                        debug_switch: e.target.checked,
                                        prompt_data: basePromptValue,
                                        initial_message: initialMessage,
                                      });
                                    }}
                                    checked={switchChange}
                                  />
                                  <label htmlFor="debugSwitch">Toggle</label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <button
                            type="button"
                            className="btn dropdown-toggle"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offCanvasSettingsRight"
                            aria-controls="offCanvasSettingsRight"
                          >
                            <img src={images["setting-chat.svg"]} alt="" />
                          </button>
                        </div> */}
                      </div>
                      <div className="mobile-view">
                        <FilterComponent
                          isMobile={true}
                          headCells={filterMenu}
                          filterOptions={filterOptions}
                          setFilterOption={setFilterOption}
                          filterOption={filterOption}
                          selectedConversationName={selectedConversationName}
                          selectedConversation={selectedConversation}
                          payloadData={payloadData.current}
                          setSelectedOptions={setSelectedOptions}
                          selectedOptions={selectedOptions}
                          selectedLabelOptions={selectedLabelOptions}
                          setSelectedLabelOptions={setSelectedLabelOptions}
                          selectedFilter={selectedFilter}
                          setSelectedFilter={setSelectedFilter}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div
                        className={
                          referenceDocument !== ""
                            ? `col-12 col-md-12 col-lg-6 col-xl-6`
                            : "col-12 col-md-12 col-lg-12 col-xl-12"
                        }
                      >
                        <div className="chat-box-main qa-chat-main">
                          <div className="chat-box">
                            <div className="cnv-box qa-chat-box">
                              {loadingPropmptData.length !== 0 &&
                                loadingPropmptData.map((_data, _idx) => (
                                  <>
                                    <div className="qa-top-block">
                                      <h2>{_data.question}</h2>
                                      <div className="title-bottom-note">
                                        <div className="new-ld-btn">
                                          <span className="btn like-btn pe-none">
                                            <img
                                              alt=""
                                              className=""
                                              src={images["new-like.svg"]}
                                            />
                                          </span>
                                          <span className="btn like-btn pe-none">
                                            <img
                                              alt=""
                                              className=""
                                              src={images["new-dislike.svg"]}
                                            />
                                          </span>
                                        </div>
                                        <p>
                                          <span className="note-lg">
                                            Thumbs Up or Down
                                          </span>{" "}
                                          - Give a Thumbs Up or Down to show if
                                          an answer was correct. This helps to
                                          evaluate and tweak the pipeline to get
                                          <br /> better results in the feature{" "}
                                        </p>
                                      </div>
                                    </div>
                                    {_data?.optionalAnswer1 !== false &&
                                      _data?.optionalAnswer1 !== undefined &&
                                      _data?.optionalAnswer1.length !== 0 &&
                                      _data?.optionalAnswer1.map(
                                        (_sourceData, _idx) => (
                                          <>
                                            <div className="ans-chat">
                                              <div className="ans-block">
                                                <div className="ans-title">
                                                  <h3>
                                                    {_sourceData?.fileTitle}
                                                  </h3>
                                                  <h4>
                                                    <img
                                                      alt=""
                                                      className="me-1"
                                                      src={
                                                        images["icn_done.svg"]
                                                      }
                                                    />{" "}
                                                    Relevance:{" "}
                                                    {`${(
                                                      _sourceData.certainty *
                                                      100
                                                    ).toFixed(2)}%`}
                                                  </h4>
                                                </div>
                                                <div className="ans-disc">
                                                  <p>
                                                    Lorem Ipsum is simply dummy
                                                    text of the printing and
                                                    typesetting industry. Lorem
                                                    Ipsum has been the
                                                    industry's standard dummy
                                                    text{" "}
                                                    <span className="highlight-msg">
                                                      ever since the 1500s, when
                                                      an unknown printer took a
                                                      galley of type and
                                                      scrambled it to make a
                                                      type specimen book.
                                                    </span>{" "}
                                                    It has survived not only
                                                    five centuries, but also the
                                                    leap into electronic
                                                    typesetting, remaining
                                                    essentially unchanged. It
                                                    was popularised in the 1960s
                                                    with the release of Letraset
                                                    sheets containing Lorem
                                                    Ipsum passages, and more
                                                    recently with desktop
                                                    publishing software like
                                                    Aldus PageMaker including
                                                    versions of Lorem Ipsum. It
                                                    is a long established fact
                                                    that a reader will be
                                                    distracted by the readable
                                                    content of a page when
                                                    looking at its layout. The
                                                    point of using Lorem Ipsum
                                                    is that it has a
                                                    more-or-less normal
                                                    distribution of letters, as
                                                    opposed to using 'Content
                                                    here, content here', making
                                                    it look like readable
                                                    English. Many desktop
                                                    publishing packages and web
                                                    page editors now use Lorem
                                                    Ipsum as their default model
                                                    text, and a search for
                                                    'lorem ipsum' will uncover
                                                    many web sites still in
                                                    their infancy. Various
                                                    versions have evolved over
                                                    the years, sometimes by
                                                    accident, sometimes on
                                                    purpose (injected humour and
                                                    the like).
                                                  </p>
                                                </div>
                                                <div className="ans-bottom">
                                                  <div className="row align-items-center">
                                                    <div className="col-6">
                                                      <div className="ans-ld-btn">
                                                        <span className="btn like-btn active">
                                                          <img
                                                            alt=""
                                                            className=""
                                                            src={
                                                              images[
                                                                "icn_like_active.svg"
                                                              ]
                                                            }
                                                          />
                                                        </span>
                                                        <span className="btn like-btn">
                                                          <img
                                                            alt=""
                                                            className=""
                                                            src={
                                                              images[
                                                                "new-dislike.svg"
                                                              ]
                                                            }
                                                          />
                                                        </span>
                                                      </div>
                                                    </div>
                                                    <div className="col-6 text-end">
                                                      <button className="btn btn-primary-md">
                                                        <img
                                                          alt=""
                                                          className="me-1"
                                                          src={
                                                            images[
                                                              "new_icn_chat.svg"
                                                            ]
                                                          }
                                                        />{" "}
                                                        Chat
                                                      </button>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </>
                                        )
                                      )}
                                  </>
                                ))}
                            </div>
                            <div className="chat-form">
                              <ChatPageFooter
                                setReferenceDocument={setReferenceDocument}
                                initialMessage={initialMessage}
                                loadingPropmptData={loadingPropmptData}
                                handleFaqSend={handleFaqSend}
                                setInputtedQuestion={setInputtedQuestion}
                                inputedQuestion={inputedQuestion}
                                loading={loading}
                                setTypeOfAnswer={setTypeOfAnswer}
                                scrollToBottom={scrollToBottom}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className={
                          referenceDocument !== "" &&
                          `col-12 col-md-12 col-lg-6 col-xl-6 doc-prv-col`
                        }
                      >
                        {referenceDocument && documentType === "doc" && (
                          <>
                            <button
                              type="button"
                              className="btn btn-close prv-cancel-btn text-right"
                              onClick={() => {
                                setReferenceDocument("");
                                setDocumentPageNumber(0);
                              }}
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            ></button>

                            <div className="rpv-core__viewer  p-0">
                              <div className="prev-tools">
                                <Toolbar />
                              </div>
                              <div className="prev-scroll">
                                <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.3.122/build/pdf.worker.min.js">
                                  <Viewer
                                    initialPage={documentPageNumber - 1}
                                    fileUrl={referenceDocument}
                                    plugins={[toolbarPluginInstance]}
                                  />
                                </Worker>
                              </div>
                            </div>
                          </>
                        )}
                        {referenceDocument && documentType === "text" && (
                          <>
                            <button
                              type="button"
                              className="btn btn-close prv-cancel-btn text-right"
                              onClick={() => {
                                setReferenceDocument("");
                                setDocumentPageNumber(0);
                              }}
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            ></button>
                            <div
                              className="rpv-core__viewer"
                              dangerouslySetInnerHTML={{ __html: html }}
                            ></div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Play Role Popup */}
            <div
              className="modal fade"
              id="infoModal"
              tabIndex="-1"
              aria-labelledby="staticBackdropLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered common-modal info-modal">
                <div className="modal-content">
                  <div className="modal-header">
                    <h1 className="modal-title fs-5" id="staticBackdropLabel">
                      How to Use the Query Persona/Query Role Setting
                    </h1>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="info-scroll">
                      <p>
                        The Query Persona/Query Role setting allows you to
                        specify the role or persona that you want to use when
                        asking a question to the OpenAI chatbot. This can help
                        the chatbot generate more relevant and personalized
                        responses based on your specific context.
                      </p>
                      <p>
                        Some examples of personas or roles that you might use
                        include "Vehicle Owner," "Professional Mechanic,"
                        "Novice DIYer," "Sales Representative," "Insurance
                        Agent," and "Car Enthusiast." Each persona can provide
                        unique insights and expertise that can help generate
                        more accurate and relevant responses.
                      </p>
                      <p>
                        To use this setting, simply enter a persona or role that
                        you think would be relevant to your question in the
                        input box provided. You can experiment with different
                        personas to find the one that works best for your needs.
                      </p>
                      <p>
                        Remember, providing a persona or role can help the
                        chatbot generate better responses based on your specific
                        context, so be sure to use this setting whenever
                        possible.
                      </p>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-primary-md"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* Tones Popup */}
            <div
              className="modal fade"
              id="tonesModal"
              tabIndex="-1"
              aria-labelledby="staticBackdropLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered common-modal info-modal">
                <div className="modal-content">
                  <div className="modal-header">
                    <h1 className="modal-title fs-5" id="staticBackdropLabel">
                      Tones
                    </h1>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="info-scroll">
                      <div className="tones-block">
                        <h3>Professional</h3>
                        <p>
                          A formal and objective tone often used in business
                          writing, academic writing, and other formal settings.
                        </p>
                        <p>
                          <b>Example:</b> "Dear Sir/Madam, I am writing to
                          inquire about the current job opportunities available
                          at your company. I have attached my resume for your
                          review and consideration."
                        </p>
                      </div>
                      <div className="tones-block">
                        <h3>Casual</h3>
                        <p>
                          An informal and friendly tone often used in
                          conversation, texting, and other informal settings.
                        </p>
                        <p>
                          <b>Example:</b> "Hey there! How's it going? What have
                          you been up to lately?"
                        </p>
                      </div>
                      <div className="tones-block">
                        <h3>Enthusiastic</h3>
                        <p>
                          An energetic and passionate tone often used to convey
                          excitement, positivity, and enthusiasm.
                        </p>
                        <p>
                          <b>Example:</b> "Wow! This is amazing! I can't believe
                          how much fun we had last night!"
                        </p>
                      </div>
                      <div className="tones-block">
                        <h3>Informational</h3>
                        <p>
                          A neutral and straightforward tone often used to
                          convey information, facts, and data in a clear and
                          concise manner.
                        </p>
                        <p>
                          <b>Example:</b> "According to the latest data from the
                          World Health Organization, the number of confirmed
                          cases of COVID-19 has reached over 100 million
                          worldwide."
                        </p>
                      </div>
                      <div className="tones-block">
                        <h3>Funny</h3>
                        <p>
                          A lighthearted and humorous tone often used to make
                          people laugh or to add a touch of humor to a
                          conversation.
                        </p>
                        <p>
                          <b>Example:</b> "Why did the tomato turn red? Because
                          it saw the salad dressing!"
                        </p>
                      </div>
                      <div className="tones-block">
                        <h3>Conversational</h3>
                        <p>
                          A tone designed to mimic the way people speak in
                          conversation, often used in chatbots, customer service
                          interactions, and other contexts where a more natural,
                          conversational tone is desired.
                        </p>
                        <p>
                          <b>Example:</b> "Hi there! How can I help you today?"
                        </p>
                      </div>
                      <div className="tones-block">
                        <h3>Persuasive</h3>
                        <p>
                          A tone used to convince or influence the reader to
                          take a particular action or hold a certain belief,
                          often used in advertising, political writing, and
                          other contexts where the goal is to persuade.
                        </p>
                        <p>
                          <b>Example:</b> "Join our movement today and help make
                          a difference in your community."
                        </p>
                      </div>
                      <div className="tones-block">
                        <h3>Sarcastic</h3>
                        <p>
                          A tone characterized by irony, humor, and a slight
                          edge, often used to express humor, but can also be
                          used to criticize or mock something in a subtle way.
                        </p>
                        <p>
                          <b>Example:</b> "Oh, great. Another meeting. Just what
                          I needed today."
                        </p>
                      </div>
                      <div className="tones-block">
                        <h3>Inspirational</h3>
                        <p>
                          A positive and uplifting tone often used to inspire or
                          encourage the reader to take action or to make a
                          change.
                        </p>
                        <p>
                          <b>Example:</b> "Believe in yourself and all that you
                          are. Know that there is something inside you that is
                          greater than any obstacle."
                        </p>
                      </div>
                      <div className="tones-block">
                        <h3>Emotional</h3>
                        <p>
                          A tone designed to elicit an emotional response from
                          the reader, such as empathy, sadness, anger, or joy,
                          often used in storytelling, memoir writing, and other
                          contexts where the goal is to connect with the reader
                          on an emotional level.
                        </p>
                        <p>
                          <b>Example:</b> "She looked out the window and
                          remembered all the happy times they had shared in that
                          little house by the lake."
                        </p>
                      </div>
                      <div className="tones-block">
                        <h3>Factual</h3>
                        <p>
                          A tone characterized by an emphasis on accuracy,
                          objectivity, and concrete information, often used in
                          journalism, scientific writing, and other contexts
                          where the goal is to convey information in a
                          straightforward and credible manner.
                        </p>
                        <p>
                          <b>Example:</b> "The Earth is the third planet from
                          the Sun and is the only known planet to harbor life."
                        </p>
                      </div>
                      <div className="tones-block">
                        <h3>Creative</h3>
                        <p>
                          A tone characterized by imagination, originality, and
                          artistic expression, often used in fiction writing,
                          poetry, and other forms of artistic expression where
                          the goal is to engage the reader's imagination and
                          evoke emotional responses.
                        </p>
                        <p>
                          <b>Example:</b> "The moon was a ghostly galleon tossed
                          upon cloudy seas."
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-primary-md">
                      Yes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <ShareDocumentModal
        setDocumentLink={setDocumentLink}
        documentLink={documentLink}
        isOpen={showModal}
        toggle={() => setShowModal(false)}
        project_slug_name={demo}
        source={source}
        typeOfAnswer={typeOfAnswer}
        lengthValue={lengthValue}
        responseTone={responseTone}
      />
    </div>
  );
};
export default NewChatPage;

// https://docs.google.com/viewer?url=https://d3ectw1fovuss2.cloudfront.net/public/qa/1670493943573.pdf&embedded=true
